<template>
  <div class="testimonials">
    <!-- Testimonial-Section start -->
    <section class="row_am testimonial_section">
      <!-- container start -->
      <div class="container">
        <div
          class="section_title"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="300"
        >
          <h2>What Our <span>Clients Say</span></h2>
          <p>
            Real people. Real results. Discover why thousands of clients <br />
            trust SALT to book their perfect braid styles — effortlessly.
          </p>
        </div>

        <div
          class="testimonial_block"
          data-aos="fade-in"
          data-aos-duration="1500"
        >
          <!-- Swiper Carousel -->
          <swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="30"
            :autoplay="{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }"
            :pagination="{
              clickable: true,
            }"
            :speed="900"
            :loop="true"
            :grab-cursor="true"
            class="mySwiper"
          >
            <!-- Testimonial 1 -->
            <swiper-slide>
              <div class="item">
                <div class="testimonial_slide_box">
                  <div class="rating">
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                  </div>
                  <p class="review">
                    “I used to spend hours scrolling through Instagram to find a stylist — now I just open SALT, pick my look, and book in minutes. My box braids last longer and look better than ever!”
                  </p>
                  <div class="testimonial_img">
                    <img src="images/testimonial_user1.png" alt="Shayna John" />
                  </div>
                  <h3>Shayna John</h3>
                  <span class="designation">Creative Director | Los Angeles</span>
                </div>
              </div>
            </swiper-slide>

            <!-- Testimonial 2 -->
            <swiper-slide>
              <div class="item">
                <div class="testimonial_slide_box">
                  <div class="rating">
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                  </div>
                  <p class="review">
                    “The style gallery saved me! I showed my stylist exactly what I wanted — no more miscommunication. And the aftercare reminders? Genius.”
                  </p>
                  <div class="testimonial_img">
                    <img src="images/testimonial_user2.png" alt="Priya M" />
                  </div>
                  <h3>Derek L.</h3>
                  <span class="designation">Student | Chicago</span>
                </div>
              </div>
            </swiper-slide>

            <!-- Testimonial 3 -->
            <swiper-slide>
              <div class="item">
                <div class="testimonial_slide_box">
                  <div class="rating">
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                    <span><i class="icofont-star"></i></span>
                  </div>
                  <p class="review">
                    “As a guy who gets cornrows for workouts, SALT made it easy to find stylists who know men’s hair. Quick, clean, and always on time.”
                  </p>
                  <div class="testimonial_img">
                    <img src="images/testimonial_user3.png" alt="Cyrus Stephen" />
                  </div>
                  <h3>Cyrus Stephen</h3>
                  <span class="designation">Fitness Coach | Miami</span>
                </div>
              </div>
            </swiper-slide>
          </swiper>

          <!-- Total Reviews Section -->
          <div class="total_review">
            <div class="rating">
              <span><i class="icofont-star"></i></span>
              <span><i class="icofont-star"></i></span>
              <span><i class="icofont-star"></i></span>
              <span><i class="icofont-star"></i></span>
              <span><i class="icofont-star"></i></span>
              <p>5.0 / 5.0</p>
            </div>
            <h3>2578</h3>
            <!-- <a href="reviews.html">
              TOTAL USER REVIEWS <i class="icofont-arrow-right"></i>
            </a> -->
          </div>

          <!-- Avatar Faces -->
          <div class="avtar_faces">
            <img src="images/avtar_testimonial.png" alt="Happy clients" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
// Import Swiper Vue Components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import required Swiper modules
import { Pagination, Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// Define modules to use
const modules = [Pagination, Autoplay];
</script>

<style scoped>
/* Optional: Make pagination bullets look nicer */
:deep(.swiper-pagination-bullet) {
  width: 12px;
  height: 12px;
  background-color: #ddd;
  opacity: 1;
  transition: all 0.3s ease;
}
:deep(.swiper-pagination-bullet-active) {
  background-color: #000;
  transform: scale(1.2);
}
.swiper{padding-bottom: 50px;}
</style>